import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import DropdownSearch from "../../common/DropdownSearch";
import * as userActions from "../../../actions/userActions";

const UserSelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  users = [],
  actions,
  placeholder = "Employee",
  disabled,
  name
}) => {
  if (!users.length) {
    actions.loadUsers();
  }
  const options = users.map((u) => ({
    label: u.full_name,
    value: u._id,
    manager: u.manager,
    department: u.department
  }));

  const value =
    isMulti && Array.isArray(initialValue)
      ? options.filter((x) => initialValue.includes(x.value))
      : initialValue;

  return (
    <DropdownSearch
      required
      name={name}
      label={placeholder}
      disabled={disabled}
      data={options}
      value={value}
      onChange={onChange}
    />
  );
};

UserSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  users: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string
};

function mapStatesToProps(state) {
  return {
    users: state.reducers.users
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(UserSelect);
